import React from 'react';
import { HotelSearchForm } from "../../containers";
import { PromoSection, PromoSectionContainer, Heading } from './styles';

const Promo = () => (
  <PromoSection id="promo">
    <PromoSectionContainer>
      <Heading>Book pool time and amenities at luxury hotels</Heading>
      <HotelSearchForm />
    </PromoSectionContainer>
  </PromoSection>
);

export default Promo;
